import { isObject } from "./is-object";

export type EmptyObject = { [K in string | number]: never };

export const isEmptyObject = (value: unknown): value is EmptyObject =>
  isObject(value) && !Object.keys(value).length;
